<script lang="ts">
import type { Character } from "../character/character";

import { LocalStore } from "./localstore";


	const localstore: LocalStore<Character> = new LocalStore<Character>("character");

    let savestates: string = JSON.stringify(localstore.load(), null, 4);



</script>


<main>
    <h1>Savestates</h1>
    <textarea rows=20 bind:value={savestates}></textarea>
    <button on:click={() => localstore.save(JSON.parse(savestates))}>Import</button>

</main>